// extracted by mini-css-extract-plugin
export default {"wrapper":"TopBar-module__wrapper--zTrz_","topBar":"TopBar-module__topBar--QwNml","logo":"TopBar-module__logo--AxtwA"};